import { ReactNode } from 'react';
import { Blob } from './Blob/blob';
import { BusyIndicator } from './BusyIndicator/busyindicator';
import { Canvas } from './Canvas/canvas';
import { ChunkWrapper } from './ChunkWrapper/chunk-wrapper';
import { Disclaimer } from './Disclaimer/disclaimer';
import { DisclaimerFooter } from './DisclaimerFooter/disclaimer-footer';
import { Feedback } from './Feedback/feedback';
import { Font } from './Font/font';
import { Header } from './Header/header';
import { Hints } from './Hints/hints';
import { Intro } from './Intro/intro';
import { Main } from './Main/main';
import { PageActions } from './PageActions/page-actions';
import { PageContext } from './PageContext/page-context';
import { PageDictate } from './PageDictate/page-dictate';
import { PageHistory } from './PageHistory/page-history';
import { PageIntro } from './PageIntro/page-intro';
import { PageLoading } from './PageLoading/page-loading';
import { PageMain } from './PageMain/page-main';
import { PageMenu } from './PageMenu/page-menu';
import { PagePrompt } from './PagePrompt/page-prompt';
import { PageRoot } from './PageRoot/page-root';
import { PageStop } from './PageStop/page-stop';
import { PageStreamingIndicator } from './PageStreamingIndicator/page-streaming-indicator';
import { PageSubmit } from './PageSubmit/page-submit';
import { PageSynthesis } from './PageSynthesis/page-synthesis';
import { PageTextarea } from './PageTextarea/page-textarea';
import { PageThread } from './PageThread/page-thread';
import { PageTrigger } from './PageTrigger/page-trigger';
import { PageUpload } from './PageUpload/page-upload';
import { PoweredBy } from './PoweredBy/powered-by';
import { Prompt } from './Prompt/prompt';
import { Root } from './Root/root';
import { Scroller } from './Scroller/scroller';
import { ScrollProposition } from './ScrollProposition/ScrollProposition';
import { Stream } from './Stream/stream';
import { Suggestions } from './Suggestions/suggestions';
import { Thread } from './Thread/thread';
import { Trigger } from './Trigger/trigger';

export const LLM_COMPONENTS = {
  Blob,
  BusyIndicator,
  Canvas,
  ChunkWrapper,
  Disclaimer,
  DisclaimerFooter,
  Feedback,
  Font,
  Header,
  Hints,
  Intro,
  Main,
  PageActions,
  PageContext,
  PageDictate,
  PageHistory,
  PageIntro,
  PageLoading,
  PageMain,
  PageMenu,
  PagePrompt,
  PageRoot,
  PageStop,
  PageStreamingIndicator,
  PageSubmit,
  PageSynthesis,
  PageTextarea,
  PageThread,
  PageTrigger,
  PageUpload,
  PoweredBy,
  Prompt,
  Root,
  Scroller,
  ScrollProposition,
  Stream,
  Suggestions,
  Thread,
  Trigger,
};

export type LlmComponents = Record<string, ((props: any) => ReactNode | Promise<ReactNode>) | undefined> & typeof LLM_COMPONENTS;

export * from './CanvasOffscreen/canvas-offscreen';
export * from './Chunk/chunk';
export * from './ChunkWrapper/chunk-wrapper';
export * from './Cta/cta';
export * from './Disclaimer/disclaimer';
export * from './DisclaimerFooter/disclaimer-footer';
export * from './Feedback/feedback';
export * from './Font/font';
export * from './Grid/grid';
export * from './Main/main';
export * from './PoweredBy/powered-by';
export * from './Stream/stream';
export * from './Text/text';
export * from './ThronPlayer/thron-player';
export * from './Trigger/trigger';
export * from './VideoPlayer/video-player';

// page
export * from './PageActions/page-actions';
export * from './PageContext/page-context';
export * from './PageDictate/page-dictate';
export * from './PageHistory/page-history';
export * from './PageIntro/page-intro';
export * from './PageLoading/page-loading';
export * from './PageMain/page-main';
export * from './PageMenu/page-menu';
export * from './PagePrompt/page-prompt';
export * from './PageRoot/page-root';
export * from './PageStop/page-stop';
export * from './PageStreamingIndicator/page-streaming-indicator';
export * from './PageSubmit/page-submit';
export * from './PageSynthesis/page-synthesis';
export * from './PageTextarea/page-textarea';
export * from './PageThread/page-thread';
export * from './PageTrigger/page-trigger';
export * from './PageUpload/page-upload';
export * from './Portals/portals';

